import { render } from "./ServerStatusBanner.vue?vue&type=template&id=658f17f2"
import script from "./ServerStatusBanner.vue?vue&type=script&lang=js"
export * from "./ServerStatusBanner.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__